import styled from 'styled-components';

export const BtnContainer = styled.div`
    margin-top: 36px;
    padding: 22px 20px;
    display: flex;
    > button:not(:first-child) {
        margin-left: 12px;
    }
`;